import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChartGyrComponent} from './components/chart-gyr/chart-gyr.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {ChartCfmComponent} from './components/chart-cfm/chart-cfm.component';
import {ColorGradationComponent} from './components/color-gradation/color-gradation.component';
import {NoteFieldComponent} from './components/note-field/note-field.component';
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {AngularMaterialModule} from "../angular-material.module";

const components = [
  ChartGyrComponent,
  ChartCfmComponent,
  ColorGradationComponent,
  NoteFieldComponent
];

@NgModule({
  declarations: [
    components,
    ColorGradationComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatInputModule,
    FormsModule,
    MatIconModule,
    AngularMaterialModule,
  ],
  exports: [
    components,
  ]
})
export class SharedModule {
}
